<div class="wrapper wrapper-content mtv-directory-page animated fadeInRight row hide-list-nav-tabs">
    <div class="ibox mainPartPage"
         [class.showDetailedView]="userStatisticsService.showDetailedView"
         [ngStyle]="{width: userStatisticsService.showDetailedView ? 'calc(100% - 420px)' : '100%'}">
        <div class="ibox-content no-scroll-mode">
            <div class="component-wrapper">
                <div class="filter-part">
                    <div class="bold m-b-sm">Select Building</div>
                    <search-select ngModel name="building"
                                   (ngModelChange)="changeBuilding($event)"
                                   [data]="buildingsToSearchSelect(userStatisticsService.buildings)"></search-select>

                    <hr class="row">

                    <div class="m-b-md">
                        <div class="bold m-b-sm">
                            24 floors
                            <i class="fa fa-circle" aria-hidden="true"></i>
                            144 units
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox" id="failedCheckbox" (change)="changeFilter()">
                                <label for="failedCheckbox"><svg-checked></svg-checked></label>
                                <i class="fa fa-circle failed" aria-hidden="true"></i>
                                <span>Failed</span>
                                <span class="items-count">(42)</span>
                            </label>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox" id="notInvitedCheckbox" (change)="changeFilter()">
                                <label for="notInvitedCheckbox"><svg-checked></svg-checked></label>
                                <i class="fa fa-circle not-invited" aria-hidden="true"></i>
                                <span>Not Invited</span>
                                <span class="items-count">(6)</span>
                            </label>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox" id="invitedCheckbox" (change)="changeFilter()">
                                <label for="invitedCheckbox"><svg-checked></svg-checked></label>
                                <i class="fa fa-circle invited" aria-hidden="true"></i>
                                <span>Invited</span>
                                <span class="items-count">(36)</span>
                            </label>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox" id="joinedCheckbox" (change)="changeFilter()">
                                <label for="joinedCheckbox"><svg-checked></svg-checked></label>
                                <i class="fa fa-circle joined" aria-hidden="true"></i>
                                <span>Joined</span>
                                <span class="items-count">(60)</span>
                            </label>
                        </div>
                    </div>

                    <button type="button" class="btn btn-primary">Resend Invitations</button>
                </div>
                <div class="units-part">
                    <ul class="units-list">
                        <li class="failed">7000</li>
                        <li class="not-invited">7001</li>
                        <li class="invited">7002</li>
                        <li class="joined">7003</li>
                        <li class="failed">7004</li>
                        <li class="invited">7005</li>
                        <li class="joined">7006</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/user-statistics/user-statistics.component.html